<!-- FormSelection.vue -->
<template>

  <div>
    <div class="content-wrapper">
      <div class="card card-with-shadow border-0">
        <div class="card-header p-primary bg-transparent">
          <div class="row">
            <div class="col-md-6">
              <label>Select a Form:</label>
              <app-input
                type="search-select"
                :placeholder="$t('select_a_form')"
                :list="forms"
                v-model="selectedFormId"
                :required="true"
              />
              <button class="btn btn-primary text-right mt-3" type="submit" @click="nextStep" v-if="selectedFormId">Next</button>
            </div>
          </div>
          <!-- <select v-model="selectedFormId">
            <option value="">Select a form...</option>
            <option v-for="form in forms" :key="form.id" :value="form.id">{{ form.value }}</option>
          </select> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { FormMixin } from "../../../../core/mixins/form/FormMixin";
import AppLibrary from "../../../Helpers/AppLibrary";
import {axiosGet} from "../../../Helpers/AxiosHelper";
import {BUYER_CERTIFICATE_FORMS} from "../../../Config/ApiUrl";

export default {
  mixins: [FormMixin],
  extends: AppLibrary,
  data() {  
    return {
      selectedFormId: '', // Store the selected form ID separately
      forms: [],
      selectedItemName: '',
    };
  },
  computed: {},
  watch: {
    selectedFormId(newValue) {
      // Update the selectedFormId whenever selectedForm changes
      this.selectedForm = newValue;
      this.$store.commit('setSelectedFormRevisionId', newValue);
    },
  },
  methods: {
    getForms() {
      axiosGet(BUYER_CERTIFICATE_FORMS)
          .then((res) => {
            this.forms = res.data;
          })
          .catch((error) => {
            this.$toastr.s(error.data.message);
          });
    },
    nextStep() {
      const selectedItem = this.forms.find(item => item.id === this.selectedForm);
      this.selectedItemName = selectedItem ? selectedItem.value : null;
      this.$store.commit('updateSharedData', {index: "selectedFormText", newValue: this.selectedItemName});

      this.$emit('next');
    },
  },
  mounted() {
    this.getForms();
    // Initialize selectedForm with the stored selectedFormId
    this.selectedForm = this.selectedFormId;


  },
};
</script>
